import { VALUATIONS_PERCENTILE_LABEL } from '../../../../common/constants/valuations';

const ORDINAL_NUMBERS_EXCEPTIONS = new Set([11, 12, 13]);
const ORDINAL_NUMBERS_SUFFIXES: { [key: string]: string } = { '1': 'st', '2': 'nd', '3': 'rd' };

const getPercentileLabelFromDecimal = (index: number) => {
  if (Number.isNaN(index) || index < 0 || index > 1) {
    throw new Error('Index must be a number between 0 and 1');
  }

  const percentile = Math.round(index * 100);
  const lastDigit = percentile % 10;
  const lastTwoDigits = percentile % 100;
  const percentileSuffix = ORDINAL_NUMBERS_EXCEPTIONS.has(lastTwoDigits)
    ? 'th'
    : ORDINAL_NUMBERS_SUFFIXES[lastDigit.toString()] ?? 'th';

  return `${percentile}${percentileSuffix} ${VALUATIONS_PERCENTILE_LABEL}`;
};

export default getPercentileLabelFromDecimal;
